import { FetchClientAPIKeysRoutine } from '../routines';

export const initialState = {
  isFetching: false,
  data: [],
  error: null
};

export const apiKeysListReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case FetchClientAPIKeysRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
        error: null
      };
    case FetchClientAPIKeysRoutine.REQUEST:
      return {
        ...state,
        data: [],
        isFetching: true,
        error: null
      };
    case FetchClientAPIKeysRoutine.FAILURE:
      return {
        ...state,
        data: [],
        isFetching: false,
        error: action.payload
      };

    default:
      return state;
  }
};
